<template>
  <el-dialog
    :title="$t('common.selectComponent')"
    :visible="visible"
    width="70%"
    center
    @close="handleDialogClose">
    <div class="target-container">
      <el-table
        ref="table"
        height="100%"
        border
        :data="subDeviceList"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName"
        @selection-change="handleSelectionChange"
        row-key="id">
        <el-table-column
          type="selection"
          width="55"
          :reserve-selection="true">
        </el-table-column>
        <el-table-column prop="addr" :label="$t('common.address')"/>
        <el-table-column prop="deviceName" :label="$t('common.componentName')"/>
        <el-table-column prop="deviceModel" :label="$t('common.componentModel')"/>
        <el-table-column prop="deviceNo" :label="$t('common.componentNumber')"/>
        <el-table-column prop="productionDate" :label="$t('common.productionDate')">
          <template slot-scope="scope">
            {{formatDate(scope.row.productionDate)}}
          </template>
        </el-table-column>
        <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
        <el-table-column prop="deviceSerialNo" :label="$t('common.componentSerialNo')"/>
        <el-table-column prop="status" :label="$t('common.status')">
          <template slot-scope="scope">
            {{subDeviceStatusVal(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column prop="comment" :label="$t('common.comment')" show-overflow-tooltip/>
      </el-table>
    </div>
    <pagination
      :total="totalCount"
      :pageSize="perpage"
      :current-page.sync="page"
      @current-change="onChangePage"
    />
    <span slot="footer">
        <el-button size="small" @click="close">{{$t('common.cancel')}}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submitForm">
            {{$t('common.sure')}}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
import {
  devicesList,
} from '@/api/device';
import moment from "moment";
import {defaultSubDeviceStatus} from "@/utils/defines";
import {
  Pagination,
} from '@/components';

export default {
  name: "UnSelectSubDeviceListDialog",
  props: {
    visible: Boolean,
    subDeviceIds: Array,
    deviceId: [Number, String],
    isEdit: Boolean,
  },
  components: {
    Pagination,
  },
  data() {
    return {
      subDeviceList: [],
      multipleSelection: [],
      page: 1,
      perpage: 10,
      totalCount: 0,
    };
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.page = 1;
        this.devicesList();
      }
    }
  },
  methods: {
    handleDialogClose() {
      this.close();
    },
    close() {
      this.$emit('update:visible', false);
      this.$emit('close');
      this.multipleSelection = [];
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onChangePage() {
      this.devicesList();
    },
    async devicesList() {
      const {
        page,
        perpage,
        isEdit,
        subDeviceIds,
      } = this;
      this.subDeviceList = [];
      try {
        const res = await devicesList({
          page,
          perpage,
          flag: [100, 100],
          isUsed: 0,
        });
        const { data } = res;
        let records = data.records || [];
        if (data.count !== undefined) {
          this.totalCount = data.count - (subDeviceIds ? subDeviceIds.length : 0);
        }
        if (isEdit) {
          const resSub = await devicesList({
            page,
            perpage,
            flag: [100, 100],
            deviceId: this.deviceId,
            isUsed: 1,
          });
          records = records.concat(resSub.data.records || []);
          if (resSub.data.count !== undefined) {
            this.totalCount += resSub.data.count;
          }
        }
        this.subDeviceList = records.filter(item => {
          if (isEdit) {
            if (item.deviceId) {
              if (item.deviceId !== Number.parseFloat(this.deviceId)) {
                this.totalCount--;
                return false;
              }
              if (subDeviceIds && subDeviceIds.length > 0) {
                return !subDeviceIds.includes(item.id);
              }
              return true;
            } else {
              if (subDeviceIds && subDeviceIds.length > 0) {
                return !subDeviceIds.includes(item.id);
              }
              return true;
            }
          } else {
            if (subDeviceIds && subDeviceIds.length > 0) {
              return !subDeviceIds.includes(item.id);
            }
            return true;
          }
        });
        this.$nextTick(() => {
          this.$refs.table.clearSelection();
        })
      } catch (e) {
        // do nothing.
      }
    },
    submitForm() {
      this.$emit('sure', [...this.multipleSelection]);
      this.close();
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      return updateDate.local().format('YYYY/MM/DD');
    },
    subDeviceStatusVal(row) {
      const {
        status,
      } = row;
      const subDeviceStatus = defaultSubDeviceStatus[String(status)];
      return subDeviceStatus ? subDeviceStatus.explain : status;
    },
  }
}
</script>

<style scoped>
.target-container {
  height: 50vh;
}
</style>
